"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRowHeight = void 0;
const constants_1 = require("../constants");
const getRowHeight = (itemsCount) => {
    return itemsCount <= 3 ? constants_1.DEFAULT_ROW_HEIGHT : `${100 / itemsCount}%`;
};
exports.getRowHeight = getRowHeight;
//# sourceMappingURL=getRowHeight.js.map